import parse from 'url-parse';
declare const window: any;

export enum QueryParams {
  debugMode = 'debugMode',
  sloc = 'sloc',
  IntegrationURL = 'IntegrationURL',
}

const getQueryParams = () => parse(window.location.href, true).query;

export const getQueryParam = (name: string) => getQueryParams()[name];
